import Icon1 from "../../../assets/imgs/language-learning/icon1.png";
import Icon2 from "../../../assets/imgs/language-learning/icon2.png";
import Icon3 from "../../../assets/imgs/language-learning/icon3.png";
import Icon4 from "../../../assets/imgs/language-learning/icon4.png";
import Icon5 from "../../../assets/imgs/language-learning/icon5.png";
import Icon6 from "../../../assets/imgs/language-learning/icon6.png";
import Icon7 from "../../../assets/imgs/language-learning/icon7.png";
import Icon8 from "../../../assets/imgs/language-learning/icon8.png";
import Icon9 from "../../../assets/imgs/language-learning/icon9.png";
import Icon10 from "../../../assets/imgs/language-learning/icon10.png";

// -----------------------------------------------
import Frame1 from "../../../assets/imgs/language-learning/frame-img1.png";
import Frame2 from "../../../assets/imgs/language-learning/frame-img2.png";
import Frame3 from "../../../assets/imgs/language-learning/frame-img3.png";
import Frame4 from "../../../assets/imgs/language-learning/frame-img4.png";
import Frame5 from "../../../assets/imgs/language-learning/frame-img5.png";
import Frame6 from "../../../assets/imgs/language-learning/frame-img6.png";
import Frame7 from "../../../assets/imgs/language-learning/frame-img7.png";
import Frame8 from "../../../assets/imgs/language-learning/frame-img8.png";
import Frame9 from "../../../assets/imgs/language-learning/frame-img9.png";

export const WHY_GERMANY_DATA = [
  {
    subHeading: "living",
    heading1: "Affordable",
    heading2: "Living",
    IconImg: Icon1,
    coverImg: Frame1,
  },
  {
    subHeading: "English",
    heading1: "English-Taught",
    heading2: "Courses",
    IconImg: Icon2,
    coverImg: Frame2,
  },
  {
    subHeading: "top",
    heading1: "Top-Ranking",
    heading2: "Universities",
    IconImg: Icon3,
    coverImg: Frame3,
  },
  {
    subHeading: "job",
    heading1: "Huge Work",
    heading2: "Opportunities",
    IconImg: Icon4,
    coverImg: Frame4,
  },
  {
    subHeading: "Course",
    heading1: "Countless Courses",
    heading2: "Offered",
    IconImg: Icon5,
    coverImg: Frame5,
  },
  {
    subHeading: "visa",
    heading1: "Easier Visa",
    heading2: "PR Process",
    IconImg: Icon6,
    coverImg: Frame6,
  },
  {
    subHeading: "Top",
    heading1: "Low or zero cost of",
    heading2: "Education",
    IconImg: Icon7,
    coverImg: Frame7,
  },
  {
    subHeading: "Jobs",
    heading1: "Lots Of Scholarship",
    heading2: "Opportunities",
    IconImg: Icon8,
    coverImg: Frame8,
  },
  {
    subHeading: "Top",
    heading1: "Lucrative Pay &",
    heading2: "Growth",
    IconImg: Icon9,
    coverImg: Frame9,
  },
  {
    subHeading: "Jobs",
    heading1: "Free To Travel In Europe",
    heading2: "On A Student Visa",
    IconImg: Icon10,
    coverImg: Frame8,
  },
];
